import { ACTToolbarService } from 'src/app/angularJS/services/toolbar.service';
import { LinkBuilder } from 'src/app/angularJS/services/link-builder.service';
import { UserService } from 'src/app/angularJS/services/user/user.service';
import { DecodedItsoMessageTranslationRequestService } from 'src/app/angularJS/services/decoded-itso-message-translation-request/decoded-itso-message-translation-request.service';
import { DecodedItsoMessageService } from 'src/app/angularJS/services/decoded-itso-message/decoded-itso-message.service';
import { UsageEventService } from 'src/app/angularJS/services/usage-event/usage-event.service';
import { BreadcrumbService } from 'src/app/angularJS/services/breadcrumbs/breadcrumb.service';
import { QueryBuilder } from 'src/app/angularJS/services/query-builder.service';
import * as ExcelJs from 'exceljs';
import * as saveAs from 'file-saver';
/**
 * A controller that handles events related to displaying and filtering taps reports
 */
export class TapsReportController {

  public static $inject = [
    '$translate',
    'ACTToolbarService',
    'LinkBuilder',
    'userService',
    '$q',
    'decodedItsoMessageTranslationRequestService',
    'decodedItsoMessageService',
    '$rootScope',
    'usageEventService',
    'breadcrumbService',
    'QueryBuilder',
    '$filter'
  ];
  public translationToUsageEventRequests: Array<InterACT.Interfaces.UsageEvents.TranslationToUsageEventRequestWithMeta> = [];
  public paginatorData: InterACT.Interfaces.IPaginationData = {
    currentPage: 1,
    perPageCount: 15,
    totalCount: 0
  };
  public decodedItsoMessageDictionary: InterACT.Interfaces.IDictionary<InterACT.Interfaces.ItsoMessages.DecodedItsoMessage> = {};
  public usageEventDictionary: InterACT.Interfaces.IDictionary<InterACT.Interfaces.UsageEvents.UsageEvent> = {};
  public usageEventCreatedDateDictionary: InterACT.Interfaces.IDictionary<string> = {};
  public exportData = {
    translationToUsageEventRequests: [],
    decodedItsoMessageDictionary: {},
    usageEventDictionary: {},
    usageEventCreatedDateDictionary: {}
  };

  public filters = {
    status: 'All',
    validFrom: '',
    validTo: ''
  };

  constructor(
    private $translate: ng.translate.ITranslateService,
    private ActToolbarService: ACTToolbarService,
    private linkBuilder: LinkBuilder,
    private userService: UserService,
    private $q: ng.IQService,
    private decodedItsoMessageTranslationRequestService: DecodedItsoMessageTranslationRequestService,
    private decodedItsoMessageService: DecodedItsoMessageService,
    private $rootScope,
    private usageEventService: UsageEventService,
    private breadcrumbService: BreadcrumbService,
    private queryBuilder: QueryBuilder,
    private $filter: ng.IFilterService,
  ) {
    this.activate();
  }

  /**
   * A method that gets a page worth of decoded itso message translation requests for the supplied page
   * @param page the number of the page to get the requests for
   * @param perPage the amount of requests to get
   * @param isForExport a boolean value that indicates if the data to be retrieved is to be exported or not
   * @returns a promise that resolves once the operation is complete
   */
  public getDecodedItsoMessageTranslationRequests = (page: number, perPage: number, isForExport?: boolean) => {
    const deferred = this.$q.defer();

    if (isForExport) {
      page = null;
      perPage = 10000;
    }

    if (!perPage) {
      perPage = this.paginatorData.perPageCount;
    }

    const qParam = this.constructFilterQuery();

    this.$rootScope.showSpinner = true;
    this.decodedItsoMessageTranslationRequestService.getList(page, perPage, qParam).then((response) => {

      const allPromises = [];
      for (let c = 0; c < response.translationToUsageEventRequests.length; c++) {
        const req = response.translationToUsageEventRequests[c];
        const decodedItsoMessageId = req.translationToUsageEventRequest.translationSource.link.split('/')[2];

        let dictionary = isForExport ? this.exportData.decodedItsoMessageDictionary : this.decodedItsoMessageDictionary;
        allPromises.push(this.getDecodedItsoMessage(decodedItsoMessageId, dictionary));

        if (req.translationToUsageEventRequest.usageEvent) {
          const usageEventId = req.translationToUsageEventRequest.usageEvent.link.split('/')[2];
          let usageEventDictionary = isForExport ? this.exportData.usageEventDictionary : this.usageEventDictionary;
          let usageEventCreatedDictionary = isForExport ? this.exportData.usageEventCreatedDateDictionary : this.usageEventCreatedDateDictionary;
          allPromises.push(this.getUsageEvent(usageEventId, usageEventDictionary, usageEventCreatedDictionary));
        }
      }

      this.$q.all(allPromises).then(() => {
        if (isForExport) {
          this.exportData.translationToUsageEventRequests = response.translationToUsageEventRequests;
        } else {
          this.translationToUsageEventRequests = response.translationToUsageEventRequests;
          this.paginatorData.totalCount = response.meta.totalCount;
        }

        this.$rootScope.showSpinner = false;
        deferred.resolve();
      }).catch((error) => {
        this.$rootScope.showSpinner = false;
      });
    });

    return deferred.promise;
  };

  /**
   * A method called everytime one of the filters is changed to update the reports
   */
  public onFilterChanged() {
    this.getDecodedItsoMessageTranslationRequests(this.paginatorData.currentPage, this.paginatorData.perPageCount);
  };

  /**
   * A method called to export the report to a CSV
   */
  public exportTo = () => {
    return this.getDecodedItsoMessageTranslationRequests(null, null, true).then(() => {
      const workbook = new ExcelJs.Workbook();
      const worksheet = workbook.addWorksheet();

      let rowData = [];

      for (let c = 0; c < this.exportData.translationToUsageEventRequests.length; c++) {
        let translationToUsageEventRequest = this.exportData.translationToUsageEventRequests[c];

        let from = (<any>translationToUsageEventRequest).translationToUsageEventRequest.usageEvent ?
          this.exportData.usageEventDictionary[(<any>translationToUsageEventRequest).translationToUsageEventRequest.usageEvent.link.split('/').pop()].location.locationName :
          '';

        let tokenId = (<any>translationToUsageEventRequest).translationToUsageEventRequest.usageEvent ?
          (<any>this.exportData.usageEventDictionary[(<any>translationToUsageEventRequest).translationToUsageEventRequest.usageEvent.link.split('/').pop()].token).tokenId :
          '';

        rowData.push({
          'created': (<any>translationToUsageEventRequest.meta).created,
          'from': from,
          'to': '',
          'tokenId': tokenId,
          'status': (<any>translationToUsageEventRequest).translationToUsageEventRequest.status,
          'failureReason': (<any>translationToUsageEventRequest).translationToUsageEventRequest.failureReason
        });
      }

      this.addReportRowsToWorksheet(worksheet, rowData);

      workbook.csv.writeBuffer().then((buffer) => {
        saveAs(new Blob([buffer], { type: "text/plain;charset=utf-8" }), 'Taps Report.csv', { autoBom: true });
        this.exportData = {
          translationToUsageEventRequests: [],
          decodedItsoMessageDictionary: {},
          usageEventDictionary: {},
          usageEventCreatedDateDictionary: {}
        };
      });
    });
  }

  /**
   * A method that adds the supplied report data to the supplied worksheet
   * @param worksheet the worksheet to add the report data to
   * @param reporData the report data to add to the worksheet
   *
   */
  private addReportRowsToWorksheet(worksheet, reportData) {

    const columns = [
      { header: this.$translate.instant('TAPS_REPORT_PAGE.DATE_TIME'), key: 'created' },
      { header: this.$translate.instant('TAPS_REPORT_PAGE.ISRN'), key: 'tokenId' },
      { header: this.$translate.instant('TAPS_REPORT_PAGE.FROM'), key: 'from' },
      { header: this.$translate.instant('TAPS_REPORT_PAGE.TO'), key: 'to' },
      { header: this.$translate.instant('TAPS_REPORT_PAGE.STATUS'), key: 'status' },
      { header: this.$translate.instant('TAPS_REPORT_PAGE.ERROR'), key: 'failureReason' }
    ];


    worksheet.columns = columns;

    for (let c = 0; c < columns.length; c++) {
      worksheet.getCell(1, c + 1).value = '';
    }

    worksheet.getRow(3).values = columns.map(col => col.header);
    worksheet.addRows(reportData);
  }


  /**
   * A method that creates a query param based on the filters
   */
  private constructFilterQuery = () => {

    this.queryBuilder.newParam().fieldIs('scheme.link', this.linkBuilder.getSchemesLink(this.userService.selectedScheme.id))

    if (this.filters.status !== 'All') {
      this.queryBuilder.and();
      this.queryBuilder.fieldIs('status', this.filters.status);
    }

    if (this.filters.validFrom) {
      this.queryBuilder.and();
      this.queryBuilder.isGreaterOrEqualTo('created', '\'' + this.$filter("date")(this.filters.validFrom, "yyyy-MM-dd") + '\'');
    }

    if (this.filters.validTo) {
      this.queryBuilder.and();
      this.queryBuilder.isLessThanOrEqualTo('created', '\'' + this.$filter("date")(this.filters.validTo, "yyyy-MM-dd") + '\'');
    }

    this.queryBuilder.sortBy([{
      columnName: 'created',
      direction: 'desc'
    }]);

    return this.queryBuilder.getParam();

  };

  /**
   * A method that retrieves a decoded itso message with a given id
   * @param itsoMessageId the id of the decoded itso message to retrieve
   * @param dictionary the dictionary to store the retrieved data in
   * @returns a promise that resolves with the decoded itso message with the supplied id
   */
  private getDecodedItsoMessage(decodedItsoMessageId: string,
    dictionary: InterACT.Interfaces.IDictionary<InterACT.Interfaces.ItsoMessages.DecodedItsoMessage>) {
    const deferred = this.$q.defer();

    if (dictionary[decodedItsoMessageId]) {
      deferred.resolve();
    } else {
      this.decodedItsoMessageService.get(decodedItsoMessageId).then((response) => {
        dictionary[decodedItsoMessageId] = response.decodedItsoMessage;
        deferred.resolve();
      }).catch((error) => {
        deferred.reject(error);
      });
    }

    return deferred.promise;
  }

  /**
   * A method that retrieves a usage event with a given id
   * @param usageEventId the id of the usage event to retrieve
   * @param usageEventDictionary the dictionary to store usage events in
   * @oaram usageEventToCreatedDateDictionary the dictionary to store usage event created dates in
   * @returns a promise that resolves with the usage evetn with the supplied id
   */
  private getUsageEvent(usageEventId: string,
    usageEventDictionary: InterACT.Interfaces.IDictionary<InterACT.Interfaces.UsageEvents.UsageEvent>,
    usageEventToCreatedDateDictionary: InterACT.Interfaces.IDictionary<string>) {
    const deferred = this.$q.defer();

    if (usageEventDictionary[usageEventId]) {
      deferred.resolve();
    } else {
      this.usageEventService.get(usageEventId).then((response) => {
        usageEventDictionary[usageEventId] = response.usageEvent;
        usageEventToCreatedDateDictionary[usageEventId] = (<any>response.meta).created;
        deferred.resolve();
      }).catch((error) => {
        deferred.reject(error);
      });
    }

    return deferred.promise;
  }

  /**
   * A method which is used to instantiate our controller
   */
  private activate() {
    this.breadcrumbService.setBreadcrumbs([{
      name: 'TAPS_REPORT',
      sref: 'taps-upload'
    }]);

    this.ActToolbarService.getToolbar('primary').then((toolbar) => {
      toolbar.setTitle('TAPS_REPORT');
    });

    this.getDecodedItsoMessageTranslationRequests(1, this.paginatorData.perPageCount);
  }
}